import React, { FC } from 'react';
import { useDispatch } from 'react-redux';
import { getAnetaPackById } from 'actions/aneta-pack';
import { IAnetaPacks } from 'types';
import anetaApproved from 'style/imgs/aneta-pack-items/medal-approved.svg';
import style from './index.module.scss';
import Plate from './plate';

interface PackProps {
  active: boolean;
  data: IAnetaPacks;
  bagData?: {
    chipColor: string;
    img: string;
    id: number;
  };
  openNext: () => void;
  handleClose: () => void;
  handleChooseAnetapack?: (pack: IAnetaPacks) => void;
}

const AnetaPacksListItem: FC<PackProps> = ({
  active,
  data,
  openNext,
  handleClose,
  bagData,
  handleChooseAnetapack,
}) => {
  const dispach = useDispatch();
  return (
    <div
      onClick={() => {
        if (handleChooseAnetapack) handleChooseAnetapack(data);
        dispach(getAnetaPackById(data.id));
        openNext();
        handleClose();
      }}
      role="button"
      onKeyDown={() => null}
      tabIndex={0}
      className={`${style.AnetaPackBody}  ${active && 'active'}`}
    >
      <div className={style.AnetaPackHeader}>
        {/* <img src={ImagHeader} alt="" /> */}
        <Plate color={bagData?.chipColor} />
        <div className={style.packageName}>{data.name}</div>
      </div>
      <div className={style.AnetaPackPicture}>
        <img src={bagData?.img} alt="bag" />
        {data.anetaPackType === 'AnetaApproved' && (
          <img
            className={style.anetaApproved}
            src={anetaApproved}
            alt="anetaApproved"
          />
        )}
      </div>
      <div className={style.AnetaPackRating}>
        <div className={style.RatingStars}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 103 19"
            className={style.RatingImage}
          >
            <g fill="#e8e7ec">
              <path d="M14.9 11.4c-.2.2-.3.5-.3.8l.7 4.1c.1.3-.1.7-.4.9-.3.2-.7.2-1 .1l-3.7-1.9c-.1-.1-.3-.1-.4-.1h-.1c-.1 0-.2 0-.2.1l-3.7 1.9c-.2.1-.4.1-.6.1-.5-.1-.8-.6-.7-1.1l.7-4.1c0-.3 0-.6-.3-.8l-3-2.9c-.2-.3-.3-.7-.2-1 .1-.3.4-.6.7-.6l4.1-.6c.3 0 .6-.2.7-.5l2-3.8c0-.1.1-.2.2-.2l.1-.1.1-.1h.1l.1-.1h.4c.3 0 .6.2.7.5l1.8 3.7c.1.3.4.5.7.5l4.1.6c.4 0 .6.3.8.6.1.3 0 .7-.2.9l-3.2 3.1zM35.9 11.4c-.2.2-.3.5-.3.8l.7 4.1c.1.3-.1.7-.4.9-.3.2-.7.2-1 .1l-3.7-1.9c-.1-.1-.3-.1-.4-.1h-.2c-.1 0-.2 0-.2.1l-3.7 1.9c-.2.1-.4.1-.6.1-.5-.1-.8-.6-.7-1.1l.7-4.1c0-.3 0-.6-.3-.8l-3-2.9c-.3-.2-.3-.6-.2-.9.1-.3.4-.6.7-.6l4.1-.6c.3 0 .6-.2.7-.5L30.2 2c0-.1.1-.2.2-.2l.1-.1.1-.1h.1l.1-.1h.4c.3 0 .6.2.7.5l1.8 3.7c.1.3.4.5.7.5l4.1.6c.3 0 .6.3.8.6.1.3 0 .7-.2.9l-3.2 3.1zM56.9 11.4c-.2.2-.3.5-.3.8l.7 4.1c.1.3-.1.7-.4.9-.3.2-.7.2-1 .1l-3.7-1.9c-.1-.1-.3-.1-.4-.1h-.2c-.1 0-.2 0-.2.1l-3.7 1.9c-.2.1-.4.1-.6.1-.5-.1-.8-.6-.7-1.1l.7-4.1c0-.3 0-.6-.3-.8l-3-2.9c-.3-.2-.3-.6-.2-.9.1-.3.4-.6.7-.6l4.1-.6c.3 0 .6-.2.7-.5L51.2 2c0-.1.1-.2.2-.2l.1-.1.1-.1h.1l.1-.1h.4c.3 0 .6.2.7.5l1.8 3.7c.1.3.4.5.7.5l4.1.6c.3 0 .6.3.8.6.1.3 0 .7-.2.9l-3.2 3.1zM77.9 11.4c-.2.2-.3.5-.3.8l.7 4.1c.1.3-.1.7-.4.9-.3.2-.7.2-1 .1l-3.7-1.9c-.1-.1-.3-.1-.4-.1h-.2c-.1 0-.2 0-.2.1l-3.7 1.9c-.2.1-.4.1-.6.1-.5-.1-.8-.6-.7-1.1l.7-4.1c0-.3-.1-.6-.3-.8l-3-2.9c-.3-.2-.3-.6-.2-.9.1-.3.4-.6.7-.6l4.1-.6c.3 0 .6-.2.7-.5L72.2 2c0-.1.1-.2.2-.2l.1-.1.1-.1h.1l.1-.1h.4c.3 0 .6.2.7.5l1.8 3.7c.1.3.4.5.7.5l4.1.6c.3 0 .6.3.8.6.1.3 0 .7-.2.9l-3.2 3.1zM98.9 11.4c-.2.2-.3.5-.3.8l.7 4.1c.1.3-.1.7-.4.9-.3.2-.7.2-1 .1l-3.7-1.9c-.1-.1-.3-.1-.4-.1h-.2c-.1 0-.2 0-.2.1l-3.7 1.9c-.2.1-.4.1-.6.1-.5-.1-.8-.6-.7-1.1l.7-4.1c0-.3-.1-.6-.3-.8l-3-2.9c-.3-.2-.3-.6-.2-.9.1-.3.4-.6.7-.6l4.1-.6c.3 0 .6-.2.7-.5L93.2 2c0-.1.1-.2.2-.2l.1-.1.1-.1h.1l.1-.1h.4c.3 0 .6.2.7.5l1.8 3.7c.1.3.4.5.7.5l4.1.6c.3 0 .6.3.8.6.1.3 0 .7-.2.9l-3.2 3.1z" />
            </g>
            <defs>
              <path
                className={style.mask}
                id="prefix__a"
                d="M-103 0H0v19h-103z"
              />
            </defs>
            <clipPath id="prefix__b">
              <use xlinkHref="#prefix__a" overflow="visible" />
            </clipPath>
            <g clipPath="url(#prefix__b)">
              <linearGradient
                id="prefix__c"
                gradientUnits="userSpaceOnUse"
                x1={10}
                y1={17.389}
                x2={10}
                y2={1.554}
              >
                <stop offset={0} stopColor="#f5781e" />
                <stop offset={1} stopColor="#ffc148" />
              </linearGradient>
              <path
                d="M14.9 11.4c-.2.2-.3.5-.3.8l.7 4.1c.1.3-.1.7-.4.9-.3.2-.7.2-1 .1l-3.7-1.9c-.1-.1-.3-.1-.4-.1h-.1c-.1 0-.2 0-.2.1l-3.7 1.9c-.2.1-.4.1-.6.1-.5-.1-.8-.6-.7-1.1l.7-4.1c0-.3 0-.6-.3-.8l-3-2.9c-.2-.3-.3-.7-.2-1 .1-.3.4-.6.7-.6l4.1-.6c.3 0 .6-.2.7-.5l2-3.8c0-.1.1-.2.2-.2l.1-.1.1-.1h.1l.1-.1h.4c.3 0 .6.2.7.5l1.8 3.7c.1.3.4.5.7.5l4.1.6c.4 0 .6.3.8.6.1.3 0 .7-.2.9l-3.2 3.1z"
                fill="url(#prefix__c)"
              />
              <linearGradient
                id="prefix__d"
                gradientUnits="userSpaceOnUse"
                x1={31}
                y1={17.389}
                x2={31}
                y2={1.554}
              >
                <stop offset={0} stopColor="#f5781e" />
                <stop offset={1} stopColor="#ffc148" />
              </linearGradient>
              <path
                d="M35.9 11.4c-.2.2-.3.5-.3.8l.7 4.1c.1.3-.1.7-.4.9-.3.2-.7.2-1 .1l-3.7-1.9c-.1-.1-.3-.1-.4-.1h-.2c-.1 0-.2 0-.2.1l-3.7 1.9c-.2.1-.4.1-.6.1-.5-.1-.8-.6-.7-1.1l.7-4.1c0-.3 0-.6-.3-.8l-3-2.9c-.3-.2-.3-.6-.2-.9.1-.3.4-.6.7-.6l4.1-.6c.3 0 .6-.2.7-.5L30.2 2c0-.1.1-.2.2-.2l.1-.1.1-.1h.1l.1-.1h.4c.3 0 .6.2.7.5l1.8 3.7c.1.3.4.5.7.5l4.1.6c.3 0 .6.3.8.6.1.3 0 .7-.2.9l-3.2 3.1z"
                fill="url(#prefix__d)"
              />
              <linearGradient
                id="prefix__e"
                gradientUnits="userSpaceOnUse"
                x1={52}
                y1={17.389}
                x2={52}
                y2={1.554}
              >
                <stop offset={0} stopColor="#f5781e" />
                <stop offset={1} stopColor="#ffc148" />
              </linearGradient>
              <path
                d="M56.9 11.4c-.2.2-.3.5-.3.8l.7 4.1c.1.3-.1.7-.4.9-.3.2-.7.2-1 .1l-3.7-1.9c-.1-.1-.3-.1-.4-.1h-.2c-.1 0-.2 0-.2.1l-3.7 1.9c-.2.1-.4.1-.6.1-.5-.1-.8-.6-.7-1.1l.7-4.1c0-.3 0-.6-.3-.8l-3-2.9c-.3-.2-.3-.6-.2-.9.1-.3.4-.6.7-.6l4.1-.6c.3 0 .6-.2.7-.5L51.2 2c0-.1.1-.2.2-.2l.1-.1.1-.1h.1l.1-.1h.4c.3 0 .6.2.7.5l1.8 3.7c.1.3.4.5.7.5l4.1.6c.3 0 .6.3.8.6.1.3 0 .7-.2.9l-3.2 3.1z"
                fill="url(#prefix__e)"
              />
              <linearGradient
                id="prefix__f"
                gradientUnits="userSpaceOnUse"
                x1={73}
                y1={17.389}
                x2={73}
                y2={1.554}
              >
                <stop offset={0} stopColor="#f5781e" />
                <stop offset={1} stopColor="#ffc148" />
              </linearGradient>
              <path
                d="M77.9 11.4c-.2.2-.3.5-.3.8l.7 4.1c.1.3-.1.7-.4.9-.3.2-.7.2-1 .1l-3.7-1.9c-.1-.1-.3-.1-.4-.1h-.2c-.1 0-.2 0-.2.1l-3.7 1.9c-.2.1-.4.1-.6.1-.5-.1-.8-.6-.7-1.1l.7-4.1c0-.3-.1-.6-.3-.8l-3-2.9c-.3-.2-.3-.6-.2-.9.1-.3.4-.6.7-.6l4.1-.6c.3 0 .6-.2.7-.5L72.2 2c0-.1.1-.2.2-.2l.1-.1.1-.1h.1l.1-.1h.4c.3 0 .6.2.7.5l1.8 3.7c.1.3.4.5.7.5l4.1.6c.3 0 .6.3.8.6.1.3 0 .7-.2.9l-3.2 3.1z"
                fill="url(#prefix__f)"
              />
              <linearGradient
                id="prefix__g"
                gradientUnits="userSpaceOnUse"
                x1={94}
                y1={17.389}
                x2={94}
                y2={1.554}
              >
                <stop offset={0} stopColor="#f5781e" />
                <stop offset={1} stopColor="#ffc148" />
              </linearGradient>
              <path
                d="M98.9 11.4c-.2.2-.3.5-.3.8l.7 4.1c.1.3-.1.7-.4.9-.3.2-.7.2-1 .1l-3.7-1.9c-.1-.1-.3-.1-.4-.1h-.2c-.1 0-.2 0-.2.1l-3.7 1.9c-.2.1-.4.1-.6.1-.5-.1-.8-.6-.7-1.1l.7-4.1c0-.3-.1-.6-.3-.8l-3-2.9c-.3-.2-.3-.6-.2-.9.1-.3.4-.6.7-.6l4.1-.6c.3 0 .6-.2.7-.5L93.2 2c0-.1.1-.2.2-.2l.1-.1.1-.1h.1l.1-.1h.4c.3 0 .6.2.7.5l1.8 3.7c.1.3.4.5.7.5l4.1.6c.3 0 .6.3.8.6.1.3 0 .7-.2.9l-3.2 3.1z"
                fill="url(#prefix__g)"
              />
            </g>
          </svg>
        </div>
        <div className={style.RatingDescription}>(15)</div>
      </div>
      {/* <div className={style.AnetaPackComments}>Some comments</div> */}
      <div
        style={!data.skills ? { display: 'none' } : {}}
        className={style.AnetaPackUse}
      >
        <span>Learning Skills</span>
        <p>{data.skills?.join(', ')}</p>
      </div>
      <div
        style={!data.interests ? { display: 'none' } : {}}
        className={style.AnetaPackUse}
      >
        <span>Interests</span>
        <p>{data.interests?.join(', ')}</p>
      </div>
      {/* <div className={style.AnetaPackUse}>
        Used: <span>2</span>
      </div> */}
    </div>
  );
};

export default AnetaPacksListItem;
